import React, { useRef } from 'react';
import {AiOutlineMail} from 'react-icons/ai'
import {BsMessenger, BsWhatsapp} from 'react-icons/bs'
import './Contact.css'
import emailjs from 'emailjs-com'
const Contact = () => {

    const form=useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_jm9tv2k', 'template_a8qgn2r', form.current, 'GpZSMOs3IYmCsNUcL')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });

          e.target.reset()
      };
  return (
    <section id='contact'>
        <h5>Contactez-moi</h5>
        <h2>VIA</h2>
        <div className='container contact__container'>
            <div className='contact__options'>
                <article className='contact__option'>
                    <AiOutlineMail className='contact-icon'/>
                    <h4>Email</h4>
                    <h5>zakariachajae@gmail.com</h5>
                    <a href='https://mail.google.com/mail/u/0/#inbox?compose=CllgCJNsMBfjzRRJhxHnMFgDTMmTbcmGhbkhdNqvjSlMNdWJxzPpnDLrsPRCPMmPpWBWHSNdRxV'>Envoyez moi un message</a>
                </article>

                <article className='contact__option'>
                    <BsMessenger className='contact-icon'/>
                    <h4>Messenger</h4>
                    <h5>Zakaria Chajae</h5>
                    <a href='https://m.me/100004424384963'>Envoyez moi un message</a>
                </article>

                <article className='contact__option'>
                    <BsWhatsapp className='contact-icon'/>
                    <h4>Whatsapp</h4>
                    <h5>+212 693327716</h5>
                    <a href='https://wa.me/+212693327716'>Envoyez moi un message</a>
                </article>

               

                
            </div>

            <form ref={form} onSubmit={sendEmail}>
                    <input type='text' name='name' placeholder='votre nom complet' required />
                    <input type='text' name='email' placeholder='votre email' required />
                    <textarea name="message" rows="7" placeholder='votre message' required></textarea>
                    <button className='btn btn-primary' >Envoyer</button>
                </form>
        </div>
    </section>
  )
}

export default Contact